// import React from 'react'

import img1 from "../../media/images/GurugramContent1.jpg";
import img2 from "../../media/images/GurugramContent2.jpg";

const LocationContentFaridabad = () => {
  return (
    <div>
      <div className="location-content">
        <div className="location-content-main">
          <div className="location-content-main-img">
            <img src={img1} title="Pet Groomers Near Me" alt="offer-imh" />
          </div>

          <div className="location-content-section">
            <h3 className="location-content-heading">
              🐕 Luxury At-Home <span>Pet Grooming</span> in <span>Faridabad</span> | FluffyTouch
</h3>
            <div className="location-content-text">
           "Serving Sector 21 to Ballabgarh - Because Your Pet Deserves the Best!".
📞 Faridabad Helpline: 96581 89189 | 🌍 Areas Covered: All Sectors, Colonies & Societies

            </div>

            <div className="location-content-image">
              <img src={img2} title="Pet Groomers Near Me" alt="offer-imh" />
            </div>

            <section>
              <div className="location-content-sub-heading">
              Faridabad Pet Problems? We’ve Got Solutions!
              </div>
              <div className="location-content-text">
                <ul>
                 
<li>Sector 15- 21D: Dusty Aravalli hikes ruining your Golden Retriever’s coat?</li>
<li>Greater Faridabad: Monsoon ticks after Badkhal Lake walks?</li>
<li>Old Faridabad: Struggling with Persian cat mats in humid weather?</li>
<li>Ballabgarh: No quality groomers near NH19?</li>

                 
                 
                </ul>
               
              </div>

              <div className="location-content-sub-heading">
              Why Faridabad Chooses Us?
              </div>
              <div className="location-content-text">
                
               ✔ Local Experts: 5+ years serving Faridabad pets
<br />✔ Apartment-Friendly: Services all high-rises in Greater Faridabad
<br />✔ Traffic-Smart: Beat NIT/Bypass Road jams with our bike groomers
                
              </div>

              <div className="location-content-sub-heading">
                Real Faridabad Reviews
              </div>
              <div className="location-content-text">
                "My Labradors in Sector 16 finally enjoy grooming!" - Rohan, Old Faridabad
<br /> "Only groomers who handle my Himalayan cat’s fur!" - Priya, Sector 21C

              </div>

     

              <div className="location-content-sub-heading">
                Areas We Cover in Faridabad
                
              </div>
              <div className="location-content-text">
                <ul>
                  <li>Old Faridabad - Sector 16, 28, NIT Area</li>
                  <li>New Faridabad - Sectors 75-89, Neharpar</li>
                </ul>
               
              </div>

              <div className="location-content-sub-heading">
              How to Book in Faridabad?
              </div>
              <div className="location-content-text">
                
                <ol>
<li>Call/WhatsApp 96581 89189</li>
<li>Choose Time Slot (8 AM-8 PM)</li>
<li>Groomer Arrives with sanitized tools</li>

                </ol>
                
              </div>
            </section>

           

            <div className="location-content-sub-heading"></div>
            <div className="location-content-text"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationContentFaridabad;
